export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/b552ae94a3baa9664c4076d726380c66.svg";